import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'

import { isEmpty } from 'src/utils/helpers'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import Loader from 'src/components/Loader/Loader'
import withToast from 'src/components/Toast'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'

class Redirect extends Component {
  componentDidMount() {
    const { getPaymentOptions } = this.props

    // Load payment options
    getPaymentOptions()
  }

  componentDidUpdate(prevProps) {
    const { intl, getPaymentOptionsResponse, toast } = this.props

    // If there is API response and it changed (it's empty object while submitting)
    if (
      !isEmpty(getPaymentOptionsResponse) &&
      getPaymentOptionsResponse !== prevProps.getPaymentOptionsResponse
    ) {
      if (!getPaymentOptionsResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            getPaymentOptionsResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
        return false
      }

      this.redirect()
    }
  }

  redirect = () => {
    const { history, isEPayPolicy, user } = this.props

    // If logged in, show list of policies
    if (!isEmpty(user)) {
      history.push('/payments/u')
      return true
    }

    // Go to ePayPolicy page
    if (isEPayPolicy) {
      history.push('/payments/e-pay')
      return true
    }

    // Redirect to login as last fallback
    history.push('/auth/login')
    return true
  }

  handleBack = () => {
    // Go home instead of back
    this.props.history.push('/')
  }

  render() {
    const { intl, features } = this.props

    const foundedFeature = features.find(f => f.id == 'payments')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.paymentHeadline)

    return (
      <Layout>
        <Content>
          <PageTitle title={title} />
          <Container>
            <Loader styleVariation='staticWithHeight' />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(Redirect)))
